// src/pages/ViewProducts.jsx
import React, { useState, useEffect } from 'react';
import styles from './ViewProducts.module.css';
import masaLogo from '../Assets/MasaLogo.png';
import api from '../api/api'; // Axios instance

const ViewProducts = () => {
  const [products, setProducts] = useState([]);
  const [searchSKU, setSearchSKU] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get('/Products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
        setErrorMessage('Failed to fetch products. Please try again.');
      }
    };
    fetchProducts();
  }, []);

  const filteredProducts = searchSKU.trim()
    ? products.filter((product) => product.SKU.toLowerCase().includes(searchSKU.toLowerCase()))
    : products;

  return (
    <main className={styles.viewProductsPage}>
      <header className={styles.header}>
        <img loading="lazy" src={masaLogo} className={styles.logo} alt="Logo" />
        <h1 className={styles.title}>All Products</h1>
      </header>

      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search by SKU..."
          value={searchSKU}
          onChange={(e) => setSearchSKU(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      {errorMessage && (
        <div className={styles.errorBanner}>
          {errorMessage}
        </div>
      )}

      <div className={styles.productGrid}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <div key={product._id} className={styles.productCard}>
              {product.image && product.image.data && product.image.contentType ? (
                <div className={styles.imageWrapper}>
                  <img
                    src={`data:${product.image.contentType};base64,${btoa(
                      new Uint8Array(product.image.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )}`}
                    alt={product.name}
                    className={styles.productImage}
                  />
                </div>
              ) : (
                <div className={styles.placeholderImage}>No Image</div>
              )}
              <h2 className={styles.productName}>{product.name}</h2>
              <p className={styles.productInfo}><strong>SKU:</strong> {product.SKU}</p>
              <p className={styles.productInfo}><strong>Size:</strong> {product.size}</p>
              {typeof product.total_quantity === 'number' && (
                <p className={styles.productInfo}><strong>Total Qty:</strong> {product.total_quantity}</p>
              )}

              {product.sorts && product.sorts.length > 0 && (
                <div className={styles.sortSection}>
                  <h3 className={styles.sortTitle}>Sorts &amp; Colors</h3>
                  {product.sorts.map((sortObj, sIndex) => (
                    <div key={sIndex} className={styles.sortContainer}>
                      <h4 className={styles.sortName}>Sort: {sortObj.sortName}</h4>
                      <ul className={styles.colorList}>
                        {sortObj.colors.map((cObj, cIndex) => (
                          <li key={cIndex} className={styles.colorItem}>
                            <span className={styles.colorName}>{cObj.color}</span> : {cObj.quantity} <span className={styles.heldQuantity}> (Held: {cObj.reservedQuantity || 0})</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={styles.noProductsMessage}>
            No product found with that SKU.
          </div>
        )}
      </div>
    </main>
  );
};

export default ViewProducts;
